var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"23a2329074dc6be4f10a2af9707e68b2dba89296"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nx_planner@smartmonkeyio"]={id:"23a2329074dc6be4f10a2af9707e68b2dba89296"};
      